// eslint-disable-next-line no-unused-vars
import React, { Component } from "react";
import { connect } from "react-redux";
import actionCreators from "../../../store/OfficeHours/Availabilities/actionCreators";
import { default as mainMenuActionCreators } from "../../../store/MainMenu/actionCreators";
import { TableComponent, RedirectButton } from "../../../common/components/Channels";
import { Dialog, Paper, Button, Typography } from "@material-ui/core";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import globalsCss from "../../../common/styles/globals.css";
import tableCss from "../../../common/styles/table.css";

import { EditIcon, DeleteIcon, EventIcon } from "../../../common/components/icons";
import PromptDialog from "../../../common/components/PromptDialog";

import { decorateTableItemsJobTypes } from "../../../common/services/decorateTableItems";

import { MainTitle } from "../../../common/components/MainTitle";
import { SubTitle } from "../../../common/components/SubTitle";
import TabsComponent from "../../../common/components/Tabs";

import {
    REPEATING_DAILY,
    REPEATING_WEEKLY,
    REPEAT_IN_TERM,
    REPEAT_IN_ACADEMIC_YEAR,
    REPEAT_N_TIMES,
    SESSION_BOOKABLE,
} from "./types";
import formsCss from "../../../common/styles/forms.css";
import { GetFormattedDate, GetFormattedTime } from "../../../common/components/Time";

import MessageForm from "./MessageForm";

const decorators = [
    {
        type: decorateTableItemsJobTypes.TRANSLATE,
        payload: {
            title: "Title",
            date: "Date",
            time: "Time",
            repeating: "Repeating configuration",
        },
    },
    {
        type: decorateTableItemsJobTypes.STYLE_ROW,
        payload: {
            date: tableCss.columnWidth200,
            time: tableCss.columnWidth300,
        },
    },
];

const buttons = (items, userId, teamId) => index => [
    {
        path: teamId
            ? `/bookings/availability/team/${teamId}/${userId}/edit/${
                  items[index] ? items[index].id : ""
              }`
            : `/bookings/availability/${userId}/edit/${items[index] ? items[index].id : ""}`,
        search: teamId ? "?academic" : undefined,
        label: "Edit",
        fnLabel: "push",
        icon: <EditIcon css={tableCss.actionsMenuItemIcon} />,
    },
    {
        path: `${items[index] ? items[index].id : null}`,
        label: "Delete",
        fnLabel: "remove",
        icon: <DeleteIcon css={tableCss.actionsMenuItemIcon} />,
    },
];

const columns = ["id", "title", "date", "time", "repeating"];

class OfficeHoursManageAvailabilityContainer extends Component {
    state = {
        removeDialog: false,
        removeDialogReason: false,
        removeId: null,
        initiated: false,
        displayCancellationSlots: false,
    };

    componentDidMount() {
        const {
            setTitle,
            clearMyOfficeHoursTeams,
            clearOneMyOfficeHoursTeam,
            getOneMyOfficeHoursAcademic,
            match,
            academic,
        } = this.props;
        clearMyOfficeHoursTeams();
        clearOneMyOfficeHoursTeam();
        setTitle("Bookings \u203A Manage Availability");
        if (!academic) {
            getOneMyOfficeHoursAcademic(match.params.userId);
        } else {
            this.initComponent();
        }
    }

    componentDidUpdate(prevProps) {
        const { academic, slotsForCancellation } = this.props;
        const { initiated } = this.state;
        if (
            !prevProps.academic &&
            academic &&
            academic.id > 0 &&
            prevProps.academic !== academic &&
            !initiated
        ) {
            this.initComponent();
        }

        if (
            slotsForCancellation !== prevProps.slotsForCancellation &&
            prevProps.slotsForCancellation === null
        ) {
            if (slotsForCancellation.length > 0) {
                // show cancellation popup
                this.props.clearLoading();
                this.setState({ removeDialogReason: true });
            } else {
                // hide popup - hide popup with empty cancellation msg
                this.onRemoveAvailability({ message: "" });
            }
        }
    }

    componentWillUnmount() {
        const { clearTitle, clearAvailabilities } = this.props;
        clearTitle();
        clearAvailabilities();
    }

    initComponent() {
        const { getUserAvailabilities, academic, getMyOfficeHoursTeams } = this.props;
        this.setState({ initiated: true }, () => {
            getUserAvailabilities({ userId: academic.id });
            getMyOfficeHoursTeams(academic.id);
        });
    }

    handleOpen = itemId => {
        this.setState({ removeDialog: true });
        this.setState({ removeId: itemId });
    };

    handleClose = confirmed => {
        this.setState({ removeDialog: false });
        if (confirmed === true) {
            this.props.getSlotsForAvailability(this.state.removeId);
        } else {
            this.setState({ removeId: null });
        }
    };

    onRemoveAvailability = values => {
        this.props.removeMyOfficeHoursAvailability({
            id: this.state.removeId,
            academicId: this.props.academic.id,
            reason: values.message,
        });
    };

    remove = itemID => {
        this.handleOpen(itemID);
    };

    render() {
        const {
            availabilities,
            history: { push },
            academic,
            teams,
            slotsForCancellation,
            errorRes: { error, errors },
        } = this.props;
        const { remove } = this;
        const { displayCancellationSlots } = this.state;

        return academic && availabilities ? (
            <div>
                <MainTitle
                    title={`${academic.firstName} ${academic.lastName}`}
                    type={"[Availability]"}
                    rightElement={
                        <RedirectButton
                            label="Calendar Preview"
                            url={`/bookings/availability/${academic.id}/preview`}
                            {...{ push }}
                            variant="text"
                            color="default"
                            elementLeft={<EventIcon css={formsCss.btnIcon} />}
                        />
                    }
                />

                <Paper elevation={1}>
                    <TabsComponent
                        activeIndex={0}
                        tabs={[
                            {
                                label: "Availability",
                                selected: true,
                                fnLabel: "push",
                                param: `/bookings/availability/${academic.id}/manage`,
                            },
                            {
                                label: "Browse sessions",
                                selected: false,
                                fnLabel: "push",
                                param: `/bookings/browse/${academic.id}`,
                            },
                        ]}
                        fns={{ push }}
                    />
                </Paper>

                <div css={globalsCss.actions}>
                    <RedirectButton
                        label="Add new availability"
                        url={`/bookings/availability/${academic.id}/new`}
                        {...{ push }}
                    />

                    <Button
                        onClick={() => push(`/bookings/availability/${academic.id}/template`)}
                        css={(formsCss.btnBack, globalsCss.helpers.ml20)}
                    >
                        Edit default settings
                    </Button>
                </div>

                {availabilities &&
                    (availabilities.filter(item => item.teamId === null).length > 0 ? (
                        <Paper elevation={1}>
                            <TableComponent
                                items={availabilities.filter(item => item.teamId === null)}
                                fns={{ push, remove }}
                                buttons={buttons(
                                    availabilities.filter(item => item.teamId === null),
                                    academic.id
                                )}
                                decorators={decorators}
                                columns={columns}
                            />
                        </Paper>
                    ) : (
                        <Paper elevation={1}>
                            <div css={globalsCss.innerSmall}>
                                You don’t have any availability set up yet
                            </div>
                        </Paper>
                    ))}

                {teams &&
                    teams.length > 0 &&
                    teams.map(team => (
                        <div key={team.id} css={globalsCss.helpers.mt30}>
                            <SubTitle
                                title={team.name}
                                type={"[Team]"}
                                css={globalsCss.subTitleMarginMobile}
                            />

                            <div css={globalsCss.actions}>
                                <RedirectButton
                                    label="Add new team availability"
                                    url={`/bookings/availability/team/${team.id}/${academic.id}/new?academic`}
                                    {...{ push }}
                                />
                            </div>

                            {availabilities &&
                                (availabilities.filter(item => item.teamId === team.id).length >
                                0 ? (
                                    <Paper elevation={1}>
                                        <TableComponent
                                            items={availabilities.filter(
                                                item => item.teamId === team.id
                                            )}
                                            fns={{ push, remove }}
                                            buttons={buttons(
                                                availabilities.filter(
                                                    item => item.teamId === team.id
                                                ),
                                                academic.id,
                                                team.id
                                            )}
                                            decorators={decorators}
                                            columns={columns}
                                        />
                                    </Paper>
                                ) : (
                                    <Paper elevation={1}>
                                        <div css={globalsCss.innerSmall}>
                                            You don’t have any availability set up for this team
                                        </div>
                                    </Paper>
                                ))}
                        </div>
                    ))}

                <PromptDialog open={this.state.removeDialog} handleClose={this.handleClose}>
                    Are you sure you want to delete this availability rule?
                </PromptDialog>

                <Dialog
                    open={this.state.removeDialogReason}
                    onClose={() => {
                        this.setState({ removeDialogReason: false, removeId: null }, () =>
                            this.props.clearSlotsForCancellation()
                        );
                    }}
                    maxWidth="sm"
                    fullWidth
                >
                    {!!slotsForCancellation && (
                        <div css={globalsCss.innerDialog}>
                            <h2 css={globalsCss.subtitleTitle}>
                                Some of your existing appointments will be cancelled
                            </h2>
                            <p>
                                Saving this change will cancel{" "}
                                <strong>{slotsForCancellation.length}</strong> existing{" "}
                                {`appointment${slotsForCancellation.length > 1 ? "s" : ""}`}. Are
                                you sure?
                            </p>

                            {displayCancellationSlots ? (
                                <div>
                                    <Button
                                        color="secondary"
                                        onClick={() =>
                                            this.setState({ displayCancellationSlots: false })
                                        }
                                    >
                                        Hide{" "}
                                        {`appointment${slotsForCancellation.length > 1 ? "s" : ""}`}
                                    </Button>
                                    <div style={globalsCss.table}>
                                        <div style={globalsCss.tableHeaderItem}>
                                            <Typography
                                                component="div"
                                                variant="subtitle1"
                                                style={globalsCss.tableItemText}
                                            >
                                                <strong>Date &amp; Time</strong>
                                            </Typography>
                                            <Typography
                                                component="div"
                                                variant="subtitle1"
                                                style={globalsCss.tableItemText}
                                            >
                                                <strong>Student</strong>
                                            </Typography>
                                        </div>
                                        {slotsForCancellation.map((slot, index) => (
                                            <div key={`slot-${index}`} style={globalsCss.tableItem}>
                                                <Typography
                                                    component="div"
                                                    variant="subtitle1"
                                                    style={globalsCss.tableItemText}
                                                >
                                                    {`${GetFormattedDate(
                                                        slot.start
                                                    )} ${GetFormattedDate(slot.start, "h.mma")}`}
                                                </Typography>
                                                <Typography
                                                    component="div"
                                                    variant="subtitle1"
                                                    style={globalsCss.tableItemText}
                                                >
                                                    {slot.student}
                                                </Typography>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <Button
                                    color="secondary"
                                    onClick={() =>
                                        this.setState({ displayCancellationSlots: true })
                                    }
                                >
                                    Show{" "}
                                    {`appointment${slotsForCancellation.length > 1 ? "s" : ""}`}
                                </Button>
                            )}

                            <p>
                                Please add a note so that students know why their appointments have
                                been cancelled. They will receive an email with your explanation.
                            </p>
                            <p>
                                Alternatively, please contact{" "}
                                <a href="mailto:studenthub@lse.ac.uk">studenthub@lse.ac.uk</a> if
                                you require any support.
                            </p>
                            {error && <div css={formsCss.genericError}>{error}</div>}
                            <MessageForm
                                {...{
                                    onSubmit: this.onRemoveAvailability,
                                    push,
                                    errors: {
                                        ...errors,
                                        ...(errors.reason ? { message: errors.reason } : {}),
                                    },
                                    fieldLabel: "Reason for cancellation",
                                    buttonLabel: "Confirm",
                                }}
                            />
                        </div>
                    )}
                </Dialog>
            </div>
        ) : (
            <div />
        );
    }
}

const dispatchToProps = {
    setTitle: mainMenuActionCreators.setTitle.create,
    clearTitle: mainMenuActionCreators.clearTitle.create,
    getOneMyOfficeHoursAcademic: actionCreators.getOneMyOfficeHoursAcademic.create,
    getUserAvailabilities: actionCreators.getUserAvailabilities.create,
    getMyOfficeHoursTeams: actionCreators.getMyOfficeHoursTeams.create,
    clearAvailabilities: actionCreators.clearAvailabilities.create,
    removeMyOfficeHoursAvailability: actionCreators.removeMyOfficeHoursAvailability.create,
    clearMyOfficeHoursTeams: actionCreators.clearMyOfficeHoursTeams.create,
    clearOneMyOfficeHoursTeam: actionCreators.clearOneMyOfficeHoursTeam.create,
    getSlotsForAvailability: actionCreators.getSlotsForAvailability.create,
    clearSlotsForCancellation: actionCreators.clearSlotsForCancellation.create,
    clearLoading: mainMenuActionCreators.clearLoading.create,
};

const getRepeatingDescription = item => {
    return item.repeatingRule
        ? item.repeatingRule.repeatEvery === 1
            ? item.repeatingRule.type === REPEATING_DAILY
                ? // daily- repeating x1
                  item.repeatingRule.finishType === REPEAT_IN_TERM
                    ? "daily in current term time"
                    : item.repeatingRule.finishType === REPEAT_IN_ACADEMIC_YEAR
                    ? "daily in term time until end of academic year"
                    : item.repeatingRule.finishType === REPEAT_N_TIMES
                    ? `daily ${item.repeatingRule.repeatTimes} times`
                    : `daily until ${GetFormattedDate(
                          item.repeatingRule.repeatDate,
                          "ddd D MMM YYYY"
                      )}`
                : item.repeatingRule.type === REPEATING_WEEKLY
                ? // weekly - repeating x1
                  item.repeatingRule.finishType === REPEAT_IN_TERM
                    ? "weekly in current term time"
                    : item.repeatingRule.finishType === REPEAT_IN_ACADEMIC_YEAR
                    ? "weekly in term time until end of academic year"
                    : item.repeatingRule.finishType === REPEAT_N_TIMES
                    ? `weekly ${item.repeatingRule.repeatTimes} times`
                    : `weekly until ${GetFormattedDate(
                          item.repeatingRule.repeatDate,
                          "ddd D MMM YYYY"
                      )}`
                : // monhtly - repeating x1
                item.repeatingRule.finishType === REPEAT_IN_TERM
                ? "monthly in current term time"
                : item.repeatingRule.finishType === REPEAT_IN_ACADEMIC_YEAR
                ? "monthly in term time until end of academic year"
                : item.repeatingRule.finishType === REPEAT_N_TIMES
                ? `monthly ${item.repeatingRule.repeatTimes} times`
                : `monthly until ${GetFormattedDate(
                      item.repeatingRule.repeatDate,
                      "ddd D MMM YYYY"
                  )}`
            : item.repeatingRule.repeatEvery > 1
            ? item.repeatingRule.type === REPEATING_DAILY
                ? // daily
                  item.repeatingRule.finishType === REPEAT_IN_TERM
                    ? `every ${item.repeatingRule.repeatEvery} days in current term time`
                    : item.repeatingRule.finishType === REPEAT_IN_ACADEMIC_YEAR
                    ? `every ${item.repeatingRule.repeatEvery} days in term time until end of academic year`
                    : item.repeatingRule.finishType === REPEAT_N_TIMES
                    ? `every ${item.repeatingRule.repeatEvery} days ${item.repeatingRule.repeatTimes} times`
                    : `every ${item.repeatingRule.repeatEvery} days until ${GetFormattedDate(
                          item.repeatingRule.repeatDate,
                          "ddd D MMM YYYY"
                      )}`
                : item.repeatingRule.type === REPEATING_WEEKLY
                ? // weekly
                  item.repeatingRule.finishType === REPEAT_IN_TERM
                    ? `every ${item.repeatingRule.repeatEvery} weeks in current term time`
                    : item.repeatingRule.finishType === REPEAT_IN_ACADEMIC_YEAR
                    ? `every ${item.repeatingRule.repeatEvery} weeks in term time until end of academic year`
                    : item.repeatingRule.finishType === REPEAT_N_TIMES
                    ? `every ${item.repeatingRule.repeatEvery} weeks ${item.repeatingRule.repeatTimes} times`
                    : `every ${item.repeatingRule.repeatEvery} weeks until ${GetFormattedDate(
                          item.repeatingRule.repeatDate,
                          "ddd D MMM YYYY"
                      )}`
                : // monhtly
                item.repeatingRule.finishType === REPEAT_IN_TERM
                ? `every ${item.repeatingRule.repeatEvery} months in current term time`
                : item.repeatingRule.finishType === REPEAT_IN_ACADEMIC_YEAR
                ? `every ${item.repeatingRule.repeatEvery} months in term time until end of academic year`
                : item.repeatingRule.finishType === REPEAT_N_TIMES
                ? `every ${item.repeatingRule.repeatEvery} months ${item.repeatingRule.repeatTimes} times`
                : `every ${item.repeatingRule.repeatEvery} months until ${GetFormattedDate(
                      item.repeatingRule.repeatDate,
                      "ddd D MMM YYYY"
                  )}`
            : "-"
        : "-";
};

const mapStateToProps = ({ OfficeHoursAvailabilities }) => ({
    academic: OfficeHoursAvailabilities.academic,
    availabilities: OfficeHoursAvailabilities.availabilities
        ? OfficeHoursAvailabilities.availabilities.map(item => {
              return {
                  id: item.id,
                  title: item.title,
                  date: GetFormattedDate(item.start, "ddd D MMM YYYY"),
                  time:
                      item.mode === SESSION_BOOKABLE
                          ? `${GetFormattedTime(item.start, "h.mma")} - ${GetFormattedTime(
                                item.end,
                                "h.mma"
                            )} (${item.slotsCount} x ${item.settings.duration} min)`
                          : `${GetFormattedTime(item.start, "h.mma")} - ${GetFormattedTime(
                                item.end,
                                "h.mma"
                            )} (drop-in)`,
                  repeating: getRepeatingDescription(item),
                  teamId: item.teamId,
              };
          })
        : OfficeHoursAvailabilities.availabilities,
    teams: OfficeHoursAvailabilities.teams
        ? OfficeHoursAvailabilities.teams.filter(team => team.userType === "member")
        : [],
    errorRes: OfficeHoursAvailabilities.errorRes,
    slotsForCancellation: OfficeHoursAvailabilities.slotsForCancellation,
});

export default connect(mapStateToProps, dispatchToProps)(OfficeHoursManageAvailabilityContainer);
